module.exports = __webpack_public_path__ + "static/media/1.20283b9c.jpg";